var CaptchaCallback = function () {
    grecaptcha.render('RecaptchaField', {'sitekey': '6Led7sckAAAAAHTmtPVPVfOl7evgb-ZjdVuY6kDV'});
};

(function ($) {
    $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null) {
            return null;
        }
        return decodeURI(results[1]) || 0;
    }

    $(document).ready(function () {
        $('#WebToLeadForm').on('submit', function (event) {
            event.preventDefault();
            var response = grecaptcha.getResponse(),
                $recaptchaValidation = $('#recaptcha-validation-message');

            $recaptchaValidation.hide();

            if (response.length == 0) {
                $recaptchaValidation.show();
            } else {
                event.target.submit();
            }
        });

        if ($.urlParam('entryPoint') && $.urlParam('entryPoint') === 'WebToLeadCapture') {
            $('.form-success.feedback').removeClass('hidden');
        }
    });
})(jQuery);
